import {
  DetalleOpStore,
  DocDetalleOpStore,
} from '@/models/store/detalleOperacionStore.model';

export const REVISION = 1;
export const APROBADA = 2;
export const CEDIDA = 3;
export const TESORERIA = 4;
export const GIRADA = 5;
export const RECHAZADA = 6;

export const operacionEstaGuardada = (estado: DetalleOpStore['estado']) =>
  estado === TESORERIA || estado === RECHAZADA || estado === GIRADA;

export const documentoEstaCedido = (d: DocDetalleOpStore) => d.estadoCesionSii;

export const existenDocumentosSinCeder = (
  documentos: DetalleOpStore['documentos'] = []
) => {
  if (documentos) {
    // Solamente tengo en cuenta a los documentos que estan activos
    const docsActivos = documentos.filter((d) => d.estado);
    // Verifico si los docs NO ELIMINADOS de la operacion fueron completamente cedidos
    return docsActivos?.some((d) => !documentoEstaCedido(d));
  }

  return true;
};
